module.exports = __webpack_public_path__ + "static/media/img-grow-thumb.76613120.png";